export default "__VITE_ASSET__CrbfxCKe__"